import React from 'react'
import Typography from '@material-ui/core/Typography'

export const Title = ({
  children
}) => {
  return (
    <Typography style={{ width: '100%', marginTop: 24 }} align='left' variant='h4'>{children}</Typography>
  )
}
export const SpacerTitle = ({
  children
}) => {
  return (
    <Typography style={{ width: '100%', margin: 24 }} align='left' variant='h4'>{children}</Typography>
  )
}
